import { render } from "./OffersSidepanel.vue?vue&type=template&id=9038165c&scoped=true"
import script from "./OffersSidepanel.vue?vue&type=script&lang=js"
export * from "./OffersSidepanel.vue?vue&type=script&lang=js"

import "./OffersSidepanel.vue?vue&type=style&index=0&id=9038165c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9038165c"]])

export default __exports__